var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',{attrs:{"value":_vm.value,"length":_vm.length,"total-visible":_vm.totalVisible},on:{"input":_vm.transition}})}
var staticRenderFns = []

export { render, staticRenderFns }